import { ChangeEventHandler, FC, FormEventHandler, useState } from 'react';
import FormSuccess from './FormSuccess';

interface Props {
  formText: string;
  buttonText: string;
}

const TextForm: FC<Props> = ({ formText, buttonText }) => {
  const [value, setValue] = useState<string>();
  const [success, setSuccess] = useState(false);

  const handleChange: ChangeEventHandler<HTMLInputElement> = e => {
    setValue(e.target.value);
  };

  const handleSubmit: FormEventHandler<HTMLFormElement> = e => {
    e.preventDefault();
    fetch(
      'https://api.hsforms.com/submissions/v3/integration/submit/1715485/955d6b13-ad59-4fe8-af3c-76e09902b73d',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          fields: [
            {
              name: 'email',
              value: value,
            },
          ],
        }),
      }
    ).then(res => {
      setSuccess(res.status === 200);
    });
  };

  return (
    <>
      {success ? (
        <FormSuccess message={`You're signed up.`} />
      ) : (
        <form
          onSubmit={handleSubmit}
          method='post'
          className='flex items-center justify-between h-16 px-2 border rounded-full border-gray-30 focus-within:border-primary'
        >
          <input
            value={value}
            onChange={handleChange}
            type='email'
            placeholder={formText}
            className='w-full h-full pl-6 text-lg rounded-l-full focus:outline-none text-gray-50 focus:text-gray-100'
          />
          <input type='submit' value={buttonText} className='ml-2 btn btn-lg btn-primary -mr-0.5' />
        </form>
      )}
    </>
  );
};

export default TextForm;
